import React, { useState, useContext, useEffect } from 'react';
import './PortfolioAccordanceDetailContent.scss';
import PortfolioAccordanceTable from '../PortfolioAccordanceTable/PortfolioAccordanceTable';
import { ProjectCounter } from '../ProjectCounter/ProjectCounter';
import { useDispatch, useSelector } from 'react-redux';
import { getPendingApprovalAccordances } from '../../../redux/actions/indicatorAccordances';
import Accordance from '../../../models/Accordance';
import Indicator from '../../../models/Indicator';
import { IndicatorKeyEnum as key } from '../../../models/IndicatorKeyEnum';
import { isMobile } from '../../../services/booleanUtil';
import { capitalizeFirstLetter, translateMultipleText } from '../../../services/stringUtil';
import { MobileAccordanceTable } from '../MobileAccordanceTable/MobileAccordanceTable';
import { addSortValues } from '../PendingTasksDetail/PendingTasksDetail';

//Added
import AccordanceDetail from '../../Util/Modals/AccordanceDetail/AccordanceDetail';
import useAccordanceDetailModalsState from '../../../hooks/useAccordanceDetailModalsState';
import AccordanceFulfilled from '../../Util/Modals/AccordanceFulfilled/AccordanceFulfilled';
import AccordanceReject from '../../Util/Modals/AccordanceReject/AccordanceReject';
import { NewAccordanceContext } from '../../Util/Modals/NewAccordance/context/NewAccordanceContext';
import { useTranslation } from 'react-i18next';
import moment from 'moment';
import { store } from '../../../redux/store';
import { handleLoading } from '../../utils';
import FilterIndicators from '../../../models/FilterIndicators';
import { AppMenuTabs } from '../../MenuTabs/userTabsInterface';
import { getNewFilteredIndicators } from '../../../api/indicatorApi';
import { setIndicatorResponse, setLoading } from '../../../redux/actions/dataTable';
import { emptyProjects } from '../../Portfolio/PortfolioUtil';
import { processIndicators } from '../../Portfolio/indicatorHelper';
import { ProjectProductTypes } from '../../../models/ProjectProductTypes';
import { arrayMove } from 'react-sortable-hoc';
import { addIndicators } from '../../../redux/actions/indicators';
import { setCurrentIndicator } from '../../../redux/actions/currentIndicator';
import { updateCreatingOrEditing } from '../../../redux/actions/menuTabs';
import { resetIndicatorDetailFilter } from '../../../redux/actions/indicatorDetailFilters';
import { ProjectsListSkeleton } from '../../LoadersSkeletons/ProjectsListSkeleton/ProjectsListSkeleton';
import ErrorMessageView from '../../Util/ErrorMessage/ErrorMessageView';
import TotalCountCard from '../shared/totalCount/TotalCountCard';
export const getAccordancesFromApi = (d, indicatorKey, setLoading, projectTypeFilterChange?) => {
  return handleLoading(
    () => d(getPendingApprovalAccordances(indicatorKey === key.ACCORDANCES_WAITING_APPROVAL ? true : false)),
    setLoading,
  );
};

interface ReceivedProps {
  currentIndicator: Indicator;
  waitingApproval?: boolean;
}

type Props = ReceivedProps;
export const PortfolioAccordanceDetailContent = (props: Props) => {
  const { t } = useTranslation();
  const { currentIndicator, waitingApproval } = props;
  const dispatch = useDispatch();
  const indicatorAccordances = useSelector<any, Accordance[]>(state => state.indicatorAccordances);
  const [nextToExpired, setNextToExpired] = useState(false);
  const [allIndicators, setAllIndicators] = useState(true);
  const [allIndicatorsFlag, setAllIndicatorsFlag] = useState<boolean>(false);
  const [showDetail, setShowDetail] = React.useState(false);
  const [refresAcordacnceInfo, setRefresAcordacnceInfo] = React.useState(false);
  const [loadingData, setLoadingData] = React.useState<boolean>(false);
  const [hasError, setHasError] = useState(false);

  const projectTypeFilterOnDetail = useSelector<any, any>(
    state => state.indicatorDetailFilter.projectTypeFilterOnDetail,
  );

  const [accordance, setAccordance] = React.useState<Accordance>();

  //added
  const [accordanceSelected, setAccordanceSelected] = React.useState<Accordance>();
  const currentDate = new Date();
  const stateProps = useAccordanceDetailModalsState();
  const { state, setState } = useContext(NewAccordanceContext);
  const { changeStatus, showFulfilledModal, setShowFulfilledModal, showReject, setShowReject, showJustificationModal } =
    stateProps;

  const [mobileSelectedTab, setMobileSelectedTab] = React.useState(0);

  // Filter
  const filterIndicators = useSelector<any, FilterIndicators>(state => state.filterIndicators);
  const stateProjectProductTypes = useSelector<any, FilterIndicators>(
    state => state.indicatorPayload.payload.projectProductTypes,
  );
  const menuTabs = useSelector<any, AppMenuTabs>(state => state.menuTabs);
  const portfolioSelectedTab = menuTabs.portfolioSelectedTab;
  const creatingOrEditing = menuTabs.creatingOrEditing;
  const [isLoading, setIsLoading] = React.useState(false);
  const [totalProjects, setTotalProjects] = React.useState(false);
  const [flag, setFlag] = useState<boolean>(false);

  const projectTypeFilterChange = {
    ...filterIndicators,
    common: { ...filterIndicators.common, projectTypeFilters: stateProjectProductTypes },
    projectTypeFilters: stateProjectProductTypes,
  };

  const handleCommonFilterChange = async () => {
    dispatch(setLoading(true));
    setIsLoading(true);
    setHasError(false);
    try {
      const indicatorsToProcess = await getNewFilteredIndicators(
        {},
        { projectProductTypes: stateProjectProductTypes },
        {
          ...projectTypeFilterChange.common,
        },
      );
      dispatch(setIndicatorResponse(indicatorsToProcess));
      startProcessIndicators(
        indicatorsToProcess,
        translateMultipleText(` ${' '} ${portfolioSelectedTab.title}`, t),
        filterIndicators.common.projectTypeFilters,
      );
      setTotalProjects(emptyProjects(indicatorsToProcess.totalProjects));
    } catch (err) {
      setHasError(true);
      console.error(err, 'Error fetching data from indicators');
    } finally {
      dispatch(setLoading(false));
      setIsLoading(false);
    }
  };

  const startProcessIndicators = (inds, titleFromTab, projectTypeFilter = [ProjectProductTypes.Loan]) => {
    const result = processIndicators(inds, {
      titleFromTab,
      projectTypeFilter,
    });
    const elementSummary: any = result.find(elem => elem.id === 15);
    const indexSummary: number = result.indexOf(elementSummary);
    const sendEndSummary = arrayMove(result, indexSummary, result.length);

    dispatch(addIndicators(sendEndSummary));

    if (currentIndicator.indicatorKey === 'ACCORDANCES_EXPIRING') {
      dispatch(setCurrentIndicator(sendEndSummary?.find(data => data.indicatorKey === 'ACCORDANCES_EXPIRING')));
    } else if (currentIndicator.indicatorKey === 'ACCORDANCES_WAITING_APPROVAL') {
      dispatch(setCurrentIndicator(sendEndSummary?.find(data => data.indicatorKey === 'ACCORDANCES_WAITING_APPROVAL')));
    }

    setIsLoading(false);
  };

  // const tabId0OrCreatingEditing = (menuTabs, creatingOrEditing) =>
  //   menuTabs.portfolioSelectedTab.tabId === 0 || creatingOrEditing;

  useEffect(() => {
    getAccordancesFromApi(dispatch, currentIndicator.indicatorKey, setLoadingData);
  }, [currentIndicator, dispatch, projectTypeFilterOnDetail]);

  useEffect(() => {
    if (refresAcordacnceInfo) {
      getAccordancesFromApi(dispatch, currentIndicator.indicatorKey, setLoadingData);
      setRefresAcordacnceInfo(false);
    }
  }, [refresAcordacnceInfo, dispatch, currentIndicator]);

  useEffect(() => {
    if (
      filterIndicators.common.coReponsibleDivisions.length > 0 ||
      filterIndicators.common.countryId.length > 0 ||
      filterIndicators.common.divisionId.length > 0 ||
      filterIndicators.common.interestIssues.length > 0 ||
      filterIndicators.common.participantDivisions.length > 0 ||
      filterIndicators.common.regionId.length > 0 ||
      filterIndicators.common.sectors.length > 0 ||
      filterIndicators.common.teamLeaders.length > 0
    )
      handleCommonFilterChange();
    setFlag(true);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [filterIndicators.common]);

  useEffect(() => {
    dispatch(resetIndicatorDetailFilter());
    if (
      !menuTabs.firstLoad &&
      // tabId0OrCreatingEditing(menuTabs, creatingOrEditing) &&
      filterIndicators.common.coReponsibleDivisions.length === 0 &&
      filterIndicators.common.countryId.length === 0 &&
      filterIndicators.common.divisionId.length === 0 &&
      filterIndicators.common.interestIssues.length === 0 &&
      filterIndicators.common.participantDivisions.length === 0 &&
      filterIndicators.common.regionId.length === 0 &&
      filterIndicators.common.sectors.length === 0 &&
      filterIndicators.common.teamLeaders.length === 0 &&
      flag
    ) {
      handleCommonFilterChange();
      setFlag(false);

      if (creatingOrEditing) {
        dispatch(updateCreatingOrEditing(false));
      }
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [filterIndicators.common]);

  const showModal = () => {
    setShowDetail(true);
  };

  const hideModal = (data?: any) => {
    setShowDetail(false);
  };

  const handleProject = React.useCallback(AccordanceObject => {
    setMobileSelectedTab(1);
    setAccordance(AccordanceObject);
  }, []);

  const handleAccordance = (acc: Accordance) => {
    setAccordanceSelected(acc);
    showModal();
  };

  const changeAccordanceStatus = (state: number) => {
    changeStatus(state);
    hideModal();
  };

  const handleChangeState = (state: boolean) => {
    var previusState = store.getState().indicatorAccordances;
    getAccordancesFromApi(dispatch, currentIndicator.indicatorKey, setLoadingData);

    store.subscribe(() => {
      const currentState = store.getState().indicatorAccordances;

      if (previusState !== currentState) {
        if (previusState.length > 0) {
          if (!allIndicators) {
            handleAllIndicators();
          } else {
            handleNextToExpire();
            handleAllIndicators();
          }
        }
      }
      previusState = [];
    });
  };

  const handleChangeAccordanceInfo = (state: boolean) => {
    setRefresAcordacnceInfo(true);
  };

  const handleNextToExpire = () => {
    if (nextToExpired && !allIndicators) {
      setAllIndicators(true);
    } else {
      setNextToExpired(true);
      setAllIndicators(false);
    }
    setAllIndicatorsFlag(prev => !prev);
  };

  const handleExpired = () => {
    if (!nextToExpired && !allIndicators) {
      setAllIndicators(true);
    } else {
      setNextToExpired(false);
      setAllIndicators(false);
    }
    setAllIndicatorsFlag(prev => !prev);
  };

  const handleAllIndicators = () => {
    setAllIndicators(true);
    setAllIndicatorsFlag(prev => !prev);
  };

  const rejectedHandler = () => {
    handleChangeState(true);
  };

  const quantityExpired = Expire(indicatorAccordances, currentDate);
  const quantityNeXToExpired = NextToExpire(indicatorAccordances, currentDate);
  const textquantityExpired = textQuantity(quantityExpired, t);
  const textquantityNeXToExpired = textQuantity(quantityNeXToExpired, t);
  const totalCountCards = [
    {
      id: 'next-to-expire',
      value: quantityNeXToExpired,
      title: textquantityNeXToExpired,
      description: capitalizeFirstLetter(t('acc_next_expire')),
      selected: !allIndicators && nextToExpired,
      onClick: handleNextToExpire,
    },
    {
      id: 'expired',
      value: quantityExpired,
      title: textquantityExpired,
      description: capitalizeFirstLetter(t('expired')),
      selected: !allIndicators && !nextToExpired,
      onClick: handleExpired,
    },
  ];

  const filterData = () => {
    let data = allIndicators
      ? indicatorAccordances
      : nextToExpired
        ? indicatorAccordances.filter(
          x => new Date(x.newExpirationDate !== null ? x.newExpirationDate : x.expirationDate) >= currentDate,
        )
        : indicatorAccordances.filter(
          x => new Date(x.newExpirationDate !== null ? x.newExpirationDate : x.expirationDate) < currentDate,
        );

    return addSortValues(data);
  };

  return !isMobile() ? (
    <>
      {!hasError ? (
        !isLoading ? (
          <div className="portfolio-accordance-detail-content-container">

            <div className="alignCountCards">
              {totalCountCards.map(card => (
                <TotalCountCard
                  key={card.id}
                  value={card.value}
                  title={card.title}
                  description={card.description}
                  selected={card.selected}
                  onClick={card.onClick}
                />
              ))}
            </div>

            <PortfolioAccordanceTable
              accordances={filterData()}
              handleProject={handleProject}
              waitingApproval={waitingApproval}
              indicatorKey={key.ACCORDANCES_EXPIRING}
              handleAccordance={event => handleAccordance(event)}
              loading={isLoading}
              allData={allIndicatorsFlag}
            />
            <ProjectCounter
              arrayToCount={filterData()}
              countProjects={false}
              indicatorKey={currentIndicator.indicatorKey}
            />

            <>
              {showDetail && (
                <AccordanceDetail
                  isOpen={showDetail}
                  closeModal={hideModal}
                  accordance={accordanceSelected}
                  showJustificationModal={showJustificationModal}
                  onApproveHandler={value => {
                    handleChangeState(value);
                  }}
                  changeAccordanceStatus={value => {
                    changeAccordanceStatus(value);
                  }}
                  daysToExpire={daysToExpire(accordanceSelected)}
                  hideEdit={true}
                  changeState={value => {
                    handleChangeState(value);
                  }}
                  updateAccordanceInfo={value => {
                    handleChangeAccordanceInfo(value);
                  }}
                />
              )}
              <AccordanceReject
                isOpen={showReject}
                closeModal={() => {
                  setShowReject(false);
                  setState({ ...state, relatedAccordance: null });
                }}
                accordanceId={accordanceSelected?.id !== undefined ? accordanceSelected.id : 0}
                onRejectHandler={rejectedHandler}
              />
              <AccordanceFulfilled
                isOpen={showFulfilledModal}
                closeModal={() => {
                  setShowFulfilledModal(false);
                  setState({ ...state, relatedAccordance: null });
                }}
                accordanceId={accordanceSelected?.id !== undefined ? accordanceSelected.id : 0}
                changeState={value => {
                  handleChangeState(value);
                }}
              />
            </>
          </div>
        ) : (
          <ProjectsListSkeleton />
        )
      ) : (
        <div className="errorMessageContainer">
          <ErrorMessageView
            title={t('title_error_message_view')}
            description={t('desc_error_message_tab')}
            reload={handleCommonFilterChange}
            isIndicator={true}
          />
        </div>
      )}

    </>
  ) : (
    <MobileAccordanceTable
      indicatorAccordances={indicatorAccordances}
      handleProject={handleProject}
      rowSelected={accordance}
      selectedTab={mobileSelectedTab}
    />
  );
};

export const NextToExpire = (accordances, currentDate) => {
  return accordances.filter(
    x => new Date(x.newExpirationDate !== null ? x.newExpirationDate : x.expirationDate) >= currentDate,
  ).length;
};
export const Expire = (accordances, currentDate) => {
  return accordances.filter(
    x => new Date(x.newExpirationDate !== null ? x.newExpirationDate : x.expirationDate) < currentDate,
  ).length;
};
export const daysToExpire = accordance => {
  let currentDate = new Date();
  let dateToExpire = accordance.newExpirationDate !== null ? accordance.newExpirationDate : accordance.expirationDate;
  return moment(new Date(dateToExpire)).diff(currentDate, 'days') + 1;
};
export const textQuantity = (days: number, t) => {
  return days === 1 ? `${capitalizeFirstLetter(t('accordance'))}` : `${capitalizeFirstLetter(t('accordances'))}`;
};
